import React from 'react'
import PrintView from '../../components/PrintView/PrintView'
import image from '../../assets/images/kuruttu-product.jpg'

const BraveFearless = () => {
  return <PrintView
    title='I am Brave , Fearless , Bold & Strong'
    heading='I am Brave , Fearless , Bold & Strong'
    content='She fears no evil. This picture was captured in Wilpaththu National Park. And this image is of a famous female leopard. Very rarely we get to witness a leopard on white sand, so this makes it a rare picture. This image is taken with high resolution for viewers have a better look of the leopardess.'
    printImage={image}
   />
}

export default BraveFearless